

import { defineComponent} from 'vue'

export default defineComponent({
  props: {
    name: {Type: String, required: true},
    icon: {Type: String, required: true},
    to: {Type: String, required: true},
  },
  computed: {
    iconPath() {
      return require(`@/assets/images/icons/${this.icon}`)
    }
  }

})
